/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const DivWrapper = ({
  className,
  faSolidCheck = "/img/fa-solid-check-circle.png",
  vector = "/img/vector-9.png",
  img = "/img/vector-10.png",
  vector1 = "/img/vector-11.png",
  vector2 = "/img/vector-12.png",
  materialSymbols = "/img/material-symbols-search.png",
  vector3 = "/img/vector-9-1.png",
  vector4 = "/img/vector-10-1.png",
  vector5 = "/img/vector-11-1.png",
  vector6 = "/img/vector-12-1.png",
}) => {
  return (
    <div className={`div-wrapper ${className}`}>
      <div className="overlap-group">
        <img className="fa-solid-check" alt="Fa solid check" src={faSolidCheck} />
        <div className="text-wrapper-17">info@techpulseinnovations.com</div>
        <div className="rectangle" />
        <div className="rectangle-2" />
        <img className="img" alt="Vector" src={vector} />
        <div className="text-wrapper-18">hq@alloyfabricationcorp.com</div>
        <div className="rectangle-3" />
        <div className="rectangle-4" />
        <img className="vector-2" alt="Vector" src={img} />
        <div className="text-wrapper-19">hello@tiemsteelsolutions.com</div>
        <div className="rectangle-5" />
        <div className="rectangle-6" />
        <img className="vector-3" alt="Vector" src={vector1} />
        <div className="text-wrapper-20">contact@steelcoreindustries.com</div>
        <div className="rectangle-7" />
        <img className="vector-4" alt="Vector" src={vector2} />
        <div className="rectangle-8" />
        <div className="text-wrapper-21">info@industrialmetalsolutions.com</div>
        <div className="rectangle-9" />
        <p className="p">Steel Companies in Amsterdam, NL</p>
        <img className="material-symbols" alt="Material symbols" src={materialSymbols} />
        <img className="vector-5" alt="Vector" src={vector3} />
        <img className="vector-6" alt="Vector" src={vector4} />
        <img className="vector-7" alt="Vector" src={vector5} />
        <img className="vector-8" alt="Vector" src={vector6} />
      </div>
    </div>
  );
};

DivWrapper.propTypes = {
  faSolidCheck: PropTypes.string,
  vector: PropTypes.string,
  img: PropTypes.string,
  vector1: PropTypes.string,
  vector2: PropTypes.string,
  materialSymbols: PropTypes.string,
  vector3: PropTypes.string,
  vector4: PropTypes.string,
  vector5: PropTypes.string,
  vector6: PropTypes.string,
};
